export default __webpack_public_path__ + "svg/calendar/2027/7/noviembre.svg?98deba2b";